module.exports = __webpack_public_path__ + "img/patients-icon-orange.4e1ded6d.svg";